// Мягкая карточка «Выберите команды» (HQ-726, решение владельца 22.10 В2 «а»): на первом экране (вкладка «Главная»,
// а пока её нет в tab_bar — наверху «Матчей»), только при сессии и пустом избранном; «Пропустить» прячет её на 7 дней.
// Игру и её обучение не задерживает — в мире игры карточки нет. Здесь — правило показа, отметка пропуска и события воронки; вид — PickTeamsCard / PickTeamsScreen.
import { track } from '../../analytics/track';

/** Экран выбора: имя экрана в аналитике — onboarding_favorites (шаблон ^onboarding_ словаря screen_name). */
export const PICK_TEAMS_ROUTE = '/onboarding/favorites';
export const SKIP_KEY = 'cricket.pick_teams.skipped_at';
export const SKIP_DAYS = 7;
const DAY_MS = 86_400_000;
/** Откуда открыт сценарий (flow_source) и имя «шага» самой карточки в воронке. */
export const FLOW_SOURCE = 'home_card';
export const CARD_STEP = 'pick_teams_card';

/** Когда человек нажал «Пропустить» (мс); нет отметки или мусор — null. */
export function skippedAt(): number | null {
  try {
    const raw = Number(localStorage.getItem(SKIP_KEY));
    return Number.isFinite(raw) && raw > 0 ? raw : null;
  } catch { return null; }
}

/** Пропуск ещё действует: прошло меньше 7 суток. Отметка «из будущего» (перевели часы) — не прячет навсегда. */
export function skipActive(now: number = Date.now(), at: number | null = skippedAt()): boolean {
  return at !== null && at <= now && now - at < SKIP_DAYS * DAY_MS;
}

/** Правило показа: есть сессия, набор пришёл с сервера и пуст, пропуск не действует, онбординг (HQ-1092) не пройден
 *  до конца (пройденный — человек уже видел выбор; пропущенный на старте — карточка остаётся мягким напоминанием). */
export function shouldShowCard(p: { session: boolean; loaded: boolean; count: number; skipped: boolean; onboarded?: boolean }): boolean {
  return p.session && p.loaded && p.count === 0 && !p.skipped && !p.onboarded;
}

/** Кнопка шага: следующий шаг или конец сценария. Конец — по концу steps (а не по action кнопки: владелец может
 *  спрятать последний шаг строкой в админке, и тогда последним станет другой). Кнопка шага — пока выбрано не меньше
 *  min_select сущностей этого типа. */
export function nextStep(index: number, total: number): { finish: true } | { finish: false; index: number } {
  return index + 1 >= total ? { finish: true } : { finish: false, index: index + 1 };
}
export const canProceed = (selected: number, minSelect: number): boolean => selected >= minSelect;

// ---- События воронки (словарь v1, группа onboarding). onboarding_skip словаря переименован в
// onboarding_step_complete с result=skip — его и шлём.
let cardSeen = false;
/** Карточка показана — один раз за запуск, не на каждый рендер главной. */
export function trackCardView(): void {
  if (cardSeen) return;
  cardSeen = true;
  track('onboarding_step_view', { step_name: CARD_STEP, step_index: 0, flow_source: FLOW_SOURCE });
}

/** Тап по карточке (continue) или «Пропустить» (skip). */
export function trackCardResult(result: 'continue' | 'skip'): void {
  track('onboarding_step_complete', { step_name: CARD_STEP, step_index: 0, flow_source: FLOW_SOURCE, result });
}

/** «Пропустить»: карточка прячется на 7 дней. */
export function skipCard(now: number = Date.now()): void {
  try { localStorage.setItem(SKIP_KEY, String(now)); } catch { /* приватный режим — до перезапуска (состояние экрана) */ }
  trackCardResult('skip');
}

type StepInfo = { key: string; index: number; variant: string };
const stepParams = (s: StepInfo) => ({ step_name: s.key, step_index: s.index, variant: s.variant || undefined, flow_source: FLOW_SOURCE });

export function trackStepView(s: StepInfo): void { track('onboarding_step_view', stepParams(s)); }
export function trackStepComplete(s: StepInfo, selection: number): void {
  track('onboarding_step_complete', { ...stepParams(s), result: 'continue', selection_count: selection });
}
export function trackComplete(variant: string): void {
  track('onboarding_complete', { variant: variant || undefined, flow_source: FLOW_SOURCE });
}
